// Text encoding required for Edge and IE 11 to support Okta sign in widget.
import 'fast-text-encoding';
// Webcrypto-shim required for IE11 to support Okta sign in widget.
import 'webcrypto-shim';
// Array slice required for IE 11 to support Okta sign in widget.
import 'core-js/modules/es6.array.from';
// Typed array support required for IE 11 to support Okta sign in widget.
import 'core-js/modules/es6.typed.uint8-array';
import { TextEncoder } from 'text-encoding';

if (typeof window.TextEncoder === 'undefined') {
    window.TextEncoder = TextEncoder;
}